import { useEffect } from 'react';
import './NotificationBadge.css';

const NotificationBadge = ({ count, setCount }) => {

  useEffect(() => {
    const handleFcmNotification = () => {
      setCount((c) => c + 1);
    };
    window.addEventListener('fcm-notification', handleFcmNotification);
    return () => window.removeEventListener('fcm-notification', handleFcmNotification);
  }, []);

  if (count < 1) return null;

  return (
    <div className="notifications-count-badge">
      {count}
    </div>
  );
};

export default NotificationBadge; 